function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FirstPageIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M8.84766 12.1265L17.6426 20.2529L19 18.7842L11.7949 12.1265L19 5.46875L17.6426 4L8.84766 12.1265Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4.84766 4H6.84766V20.25H4.84766V4Z",
    fill: "currentColor"
  }));
}
export function FirstPageIconSmall(props) {
  return ___EmotionJSX(FirstPageIcon, _extends({
    size: "small"
  }, props));
}